import { addComponent, removeComponent } from "bitecs";
import { Pinnable, Pinned, Lockeable, Locked } from "../bit-components";

AFRAME.registerComponent("lockeable", {
  schema: {
    locked: { default: false }
  },

  init() {
    addComponent(APP.world, Lockeable, this.el.object3D.eid);
  },

  update() {
    if (this.data.locked) {
      addComponent(APP.world, Locked, this.el.object3D.eid);
    } else {
      removeComponent(APP.world, Locked, this.el.object3D.eid);
    }
  },
});
